module.exports = __webpack_public_path__ + "static/media/Icons_Facebook_dark.c78e51c5.svg";